import React from 'react';
import PropTypes from 'prop-types';

const CompanyHeader = ({ data }) => {
  const { name, url } = data;
  return (
    <a href={url} className="breadcrumb-name text-truncate">
      <div className="hicon-company text-16 pr-xxxs mr-xxxs" />
      <span className="text-truncate">{name}</span>
    </a>
  );
};

CompanyHeader.propTypes = {
  data: PropTypes.object.isRequired,
};

export default CompanyHeader;
